import { faPlus } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { baseMapStateToProps } from '../componentBase';
import FormModal from '../modal/formModal';

import BaseUserForm from './baseUserForm';

interface CreateUserFormStateProps {
  email: string;
  password: string;
}

const CreateUserForm = () => {
  return (
    <FormModal
      formId={FormId.CreateUserForm}
      formTitle="New User"
      submitActionType={DataRequestActionTypes.CreateUserRequested}
      buttonIcon={faPlus}
      invertedButtonColours
    >
      <BaseUserForm formId={FormId.CreateUserForm} />
    </FormModal>
  );
};

function mapStateToProps(state: ClippingPlatformState): CreateUserFormStateProps {
  const formValues =
    state.form[FormId.CreateUserForm] && state.form[FormId.CreateUserForm].values
      ? state.form[FormId.CreateUserForm].values
      : undefined;
  const password = formValues ? formValues.password : undefined;
  const email = formValues ? formValues.email : undefined;

  return {
    ...baseMapStateToProps(state),
    email,
    password,
  };
}

export default connect(mapStateToProps)(CreateUserForm);
